import React from 'react';
import { Modal } from 'antd';

import { TagSettingsList } from './TagRefusal';
import { joinWords } from '../../utils/tags';

/**
 * The question before "Apply to new items of" WIDENS (keepr-api b75, ruled
 * 2026-09-30): a card added to a restricted tag's list puts the tag on every
 * new item of that card, so each access setting that shows items WITH the
 * tag — a public link filtered to it, a group built from it, an access level
 * — will show those new items too. The change's dry run names them
 * (utils/tags.js describeNewItemsWarning): each setting the person manages as
 * a link to where it is changed, the rest counted, the way `tag_in_use` names
 * them (TagRefusal.js TagSettingsList).
 *
 * Nothing is removed, so this is not the destructive confirm (no red); but it
 * changes who sees what, so **Keep editing** has the focus and Enter never
 * saves it. Resolves true to save, false to go back to the dialog.
 *
 *   tagName    the tag's name
 *   parts      describeNewItemsWarning's answer
 *   cardNames  the added cards' names, in the dialog's words (the warning
 *              gives ids); "the card you added" when none is known
 */
export function confirmNewItems(modalApi, { tagName = 'this tag', parts, cardNames = [] } = {}) {
	const api = modalApi && typeof modalApi.confirm === 'function' ? modalApi : Modal;
	const total = parts?.total || 0;
	const count = parts?.cardIds?.length || cardNames.length || 1;
	const cards = cardNames.length ? joinWords(cardNames) : (count === 1 ? 'the card you added' : `the ${count} cards you added`);
	return new Promise(resolve => {
		api.confirm({
			title: `Put “${tagName}” on new items of ${cards}?`,
			content: (
				<p className="tag-new-items-confirm" data-testid="tag-new-items-confirm">
					{total === 1 ? 'An access setting shows' : `${total} access settings show`}
					{` items with “${tagName}”, so ${total === 1 ? 'it' : 'they'} will show every new item of ${cards} too: `}
					<TagSettingsList references={parts?.references || []} more={parts?.more || null} />
					.
				</p>
			),
			okText: 'Save tag',
			cancelText: 'Keep editing',
			autoFocusButton: 'cancel',
			onOk: () => resolve(true),
			onCancel: () => resolve(false),
		});
	});
}

export default confirmNewItems;
